// api
import { fetchApi } from '@/api'
// actions
const restaurantReportsAux = (context, array) => true

const restaurantReportsAll = (context, array) => {
  let url = 'restaurant/reporteR'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantReportsProducts = (context, array) => {
  let url = 'restaurant/reporte/producto'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantReportsUsuario = (context, array) => {
  let url = 'restaurant/reporte/usuario'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantReportsForm = (context) => {
  let url = 'restaurant/reports/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantReportsShow = (context) => {
  let url = 'restaurant/reports'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const restaurantReportsCreate = (context) => {
  let url = 'restaurant/reports/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantReportsUpdate = (context) => {
  let url = 'restaurant/reports'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_REPORTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantReportsDelete = (context, payload) => {
  let url = 'restaurant/reports'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_REPORTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restauranteReportslistReversion = (context, array) => {
  let url = 'restaurant/reporteReversion'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  restaurantReportsAll,
  restaurantReportsProducts,
  restaurantReportsUsuario,
  restaurantReportsForm,
  restaurantReportsShow,
  restaurantReportsCreate,
  restaurantReportsUpdate,
  restaurantReportsDelete,
  restaurantReportsAux,
  restauranteReportslistReversion
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/reports/actions.js